const formStateTypes = {
   EDIT_QUESTION_TRUE: "EDIT_QUESTION_TRUE",
   EDIT_QUESTION_FALSE: "EDIT_QUESTION_FALSE",
   EDIT_ANSWER_TRUE: "EDIT_ANSWER_TRUE",
   RESET_ANSWER_STATE: "RESET_ANSWER_STATE",
};

export default formStateTypes;
